export default __webpack_public_path__ + "static/media/SEE-TICKETS_Logo_Black.01e5fb56.jpeg";